import { JobModel } from '@energy-stacks/fleet/feature-jobs-data';
import { Row } from '@tanstack/react-table';

export const sortByQuantity = <T extends JobModel>(
  rowA: Row<T>,
  rowB: Row<T>
) => {
  return rowA.original.product.quantity - rowB.original.product.quantity;
};
